import {Component, Input} from '@angular/core';
import {TabsModule} from 'primeng/tabs';
import {CardWithHeaderComponent} from '../card-with-header/card-with-header.component';

@Component({
  selector: 'app-card-with-tabs',
  imports: [
    TabsModule,
    CardWithHeaderComponent
  ],
  templateUrl: './card-with-tabs.component.html',
  styleUrl: './card-with-tabs.component.scss',
})
export class CardWithTabsComponent {

  @Input() selectedTab!:string
  @Input() leftTabHeader!:string
  @Input() rightTabHeader!:string
  @Input() hasHeader:boolean=true
  @Input() hasFooter:boolean=false
}
